import { withHTMLComponent } from '@updater-local/custom-element-v1';
import styles from './index.css';

const html = `
  <div class="background">
    <div class="shadow"></div>  
  </div>
  
  <slot></slot>
  <slot name="icon"></slot>
`;

export default class Banner extends withHTMLComponent(styles, html)() {}

customElements.define('upd-step-banner', Banner);
